import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import classnames from 'classnames';
import { withWebPageSchema } from 'decorators';
import { PSPSection } from 'components/psp/PSPSection';
import { SizeGuideHero } from 'components/organisms/SizeGuideHero';
import { PSPJumpNav } from 'components/psp/PSPJumpNav';
import { Section } from 'components/core/Page';
import './PSPLayout.scss';

export const enhance = compose(withWebPageSchema);

function PSPLayout({
	content,
	handleSearch,
	pageSchema,
	pageType,
	disableJumpSection,
	siteSchema,
}) {
	const { title, sections } = content;

	return (
		<div className={`${pageType} psp-layout`}>
			{pageType !== 'size-guide' && (
				<SizeGuideHero
					title={title}
					handleSearch={handleSearch}
				/>
			)}

			<Section>
				<div
					className={classnames('psp-page-section', {
						'disable-jump-section': disableJumpSection,
					})}
				>
					{!disableJumpSection && (
						<div className="psp-sidebar">
							<PSPJumpNav sections={sections} />
						</div>
					)}
					<div className="psp-body">
						{sections.map((section, index) => (
							<PSPSection
								modules={section.modules}
								title={section.title}
								background={section.background}
								// eslint-disable-next-line react/no-array-index-key
								key={`${section.title}-${index}`}
							/>
						))}
					</div>
				</div>
			</Section>
			<script
				key="schema"
				type="application/ld+json"
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: pageSchema }}
			/>
			{siteSchema && (
				<script
					key="schema"
					type="application/ld+json"
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{ __html: siteSchema }}
				/>
			)}
		</div>
	);
}

PSPLayout.propTypes = {
	pageSchema: PropTypes.string,
	content: PropTypes.object,
	handleSearch: PropTypes.func,
	disableJumpSection: PropTypes.bool,
	pageType: PropTypes.string,
	siteSchema: PropTypes.string,
};

export default enhance(PSPLayout);
